import { useGeneralConfiguration } from '@consolidocs-ui/hooks/useGeneralConfiguration';
import { default as useUserLanguagePreference } from '@consolidocs-ui/hooks/useUserLanguagePreference';
import { SUPPORTED_LANGUAGES } from '../i18n';
import ConsolidatesAppRoutes from '_routes/ConsolidatesAppRoutes';

interface AppContentProps {
  children?: React.ReactNode;
}

const AppContent = ({ children }: AppContentProps) => {
  const customDefaultSettingsName = 'default-settings';

  // Load general configuration on app start; the hook populates the
  // `generalConfiguration` slice, which consumers read via selectors.
  useGeneralConfiguration({
    defaultSettingsName: customDefaultSettingsName,
  });

  // Apply the language saved on the user's profile once it loads
  useUserLanguagePreference(SUPPORTED_LANGUAGES);

  return (
    <>
      {children || <ConsolidatesAppRoutes />}
    </>
  );
};

export default AppContent;